<template>
  <v-card-text>
    <v-flex mt-2 mb-2 lg12 mx-auto>
      <v-flex>
        <span class="Page__title">{{ $t('labels.inspectSuccessTitle') }}</span>
      </v-flex>
      <v-flex class="rectangle mt-3 mb-3">
        <v-card-text class="text-xs-center align-center">
          <v-flex>
            <span class="card-rectangle__title">{{ $t('labels.inspectSuccessDate') }}</span>
            <span
              class="d-block card-rectangle__text"
            >{{ formatDateTime(inspectionInfoReceiver.eventDate) }}</span>
          </v-flex>
          <v-flex class="rectangle mt-3 mb-3">
            <span class="card-rectangle__title">{{ $t('labels.inspectSuccessAddress') }}</span>
            <span class="d-block card-rectangle__text">{{ inspectionInfoReceiver.productTitle }}</span>
            <span class="d-block card-rectangle__text">{{ inspectionInfoReceiver.productAddress }}</span>
          </v-flex>
          <v-flex class="rectangle mt-3 mb-3" v-if="scheduledBy">
            <span class="card-rectangle__title">{{ $t('labels.inspectSuccessScheduledBy') }}</span>
            <span class="d-block card-rectangle__text">{{ scheduledBy }}</span>
          </v-flex>
        </v-card-text>
      </v-flex>
    </v-flex>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="isReschedulable" color="primary" class="support--background btn-md" @click="goToSchedule()">
        <span>{{ $t('labels.inspectSuccessBtn') }}</span>
      </v-btn>
    </v-card-actions>
  </v-card-text>
</template>



<script>
import { USER, EVENTS } from "@/utils/constants"
import bus from '@/utils/bus'
import enums from '@/utils/enums'
export default {
  name: "inspectionSuccess",
  props: ["inspectionInfoReceiver", "technicalDate", "isReschedulable", "scheduledBy"],

  methods: {
    async goToSchedule(){
      const params = {
        username: this.user.username
      };
      const hasAvailable = this.technicalDate.find(elem => elem.available)
      //Horarios disponiveis
      if(hasAvailable){
        this.$emit('reschedule')
      }else{
        bus.$emit('snackbar:open', {
        text: 'Não existem mais horários disponíveis. Abrir nova solicitação.',
        color: enums.snackbarColors.warning,
        })
      }
    }
  }
}

</script>


<style lang="scss" scoped>
.card-rectangle__title {
  height: 57px;
  width: 333px;
  color: #0093f0;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
  text-align: center;
}
.card-rectangle__text {
  color: #666666;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  text-align: center;
}

.card-rectangle__border {
  border: 1px solid #cccccc !important;
  border-radius: 4px !important;
}

.rectangle {
  height: auto;
  width: 100%;
  border-radius: 2px;
  background-color: #f5f5f5;
  overflow: hidden;
}
.Page__title {
  height: 33px;
  width: 202px;
  color: #0093f0;
  font-family: "Open Sans";
  font-size: 24px;
  line-height: 33px;
}
</style>



// WEBPACK FOOTER //
// src/components/support/InspectionSuccess.vue